import { Browser } from "../../utils/Browser";
import { Byte } from "../../utils/Byte";
import { WordText } from "../../utils/WordText";
import { Loader } from "../Loader";
export class JsonBinRead {
    static get instance() {
        return JsonBinRead._instance || (JsonBinRead._instance = new JsonBinRead());
    }
    static IsJsonbin(data) {
        if (data.byteLength < 5)
            return false;
        const value = (new Uint32Array(data, 0, 4))[0];
        return value == JsonBinRead.ISJSONBIN || value == JsonBinRead.ISJSONBIN2 || value == JsonBinRead.ISJSONBIN3;
    }
    static parse(value) {
        var int32 = new Int32Array(value, 0, 4);
        if (int32[0] !== JsonBinRead.ISJSONBIN && int32[0] !== JsonBinRead.ISJSONBIN2) {
            var b = new Byte();
            b.writeArrayBuffer(value);
            b.pos = 0;
            var str = b.readUTFBytes();
            return JSON.parse(str);
        }
        var r = new JsonBinRead();
        return r.read(value);
    }
    static parsePack(value) {
        var r = new JsonBinRead();
        var o = r.read(value);
        for (var key in o)
            Loader.cacheRes(key, o[key]);
        return o;
    }
    constructor() {
    }
    _readArray(data, pos, n, type, keyMap) {
        var array = [];
        array.length = n;
        var endPos;
        if (pos >= 0) {
            endPos = data.pos;
            data.pos = pos;
        }
        for (var i = 0; i < n; i++) {
            array[i] = this._readOne({}, data, null, data.readUint8(), keyMap);
        }
        if (pos >= 0) {
            data.pos = endPos;
        }
        return array;
    }
    _getLen(data) {
        let n = data.readUint8();
        return (n & 0x80) == 0 ? n : (data.readUint8() | ((n & ~0x80) << 8));
    }
    static _toLargeNumber(n1, n2) {
        let n2str = n2.toString(16);
        if (n2str.length < 7) {
            for (let i = n2str.length; i < 7; i++)
                n2str = "0" + n2str;
        }
        return parseInt(n1.toString(16) + "" + n2str, 16);
    }
    static readInt8Array(byte, start, len) {
        var end = start + len;
        end = (end > byte._length) ? byte._length : end;
        var v = new Int8Array(byte._d_.buffer.slice(start, end));
        byte._pos_ = end;
        return v;
    }
    _readOne(parent, data, key, type, keyMap) {
        let n, value;
        switch (type) {
            case JsonBinRead.NULL:
                value = null;
                break;
            case JsonBinRead.NUM8:
                value = data.readByte();
                break;
            case JsonBinRead.NUM16:
                value = data.readInt16();
                break;
            case JsonBinRead.NUM32:
                value = data.readInt32();
                break;
            case JsonBinRead.NUM64:
                value = JsonBinRead._toLargeNumber(data.readInt32(), data.readInt32());
                break;
            case JsonBinRead.BOOLEAN:
                value = data.readByte() ? true : false;
                break;
            case JsonBinRead.DOUBLE:
                value = data.readFloat32();
                break;
            case JsonBinRead.NUM16_1000:
                value = data.readInt16() / 1000;
                break;
            case JsonBinRead.NUM32_1000:
                value = data.readInt32() / 1000;
                break;
            case JsonBinRead.STRING:
                value = keyMap.keyArray[data.readUint16()][0];
                break;
            case JsonBinRead.WORDTEXT:
                n = data.readUint16();
                value = keyMap.keyArray[n][3];
                if (!value) {
                    value = keyMap.keyArray[n][3] = new WordText();
                    value.setText(keyMap.keyArray[n][0]);
                }
                break;
            case JsonBinRead.ARRAYEMPTY:
                data.readUint8();
                value = [];
                break;
            case JsonBinRead.ARRAYNUM8:
                value = [];
                value.length = n = data.readUint8();
                for (let i = 0; i < n; i++)
                    value[i] = data.readByte();
                break;
            case JsonBinRead.ARRAYNUM16:
                value = [];
                value.length = n = data.readUint8();
                for (let i = 0; i < n; i++)
                    value[i] = data.readInt16();
                break;
            case JsonBinRead.ARRAYNUM32:
                value = [];
                value.length = n = data.readUint8();
                for (let i = 0; i < n; i++)
                    value[i] = data.readInt32();
                break;
            case JsonBinRead.ARRAYDOUBLE:
                value = [];
                value.length = n = data.readUint8();
                for (let i = 0; i < n; i++)
                    value[i] = data.readFloat32();
                break;
            case JsonBinRead.ARRAYBUFFER:
                value = data.readArrayBuffer(data.readUint16());
                break;
            case JsonBinRead.ARRAYBUFFER32:
                value = data.readArrayBuffer(data.readUint32());
                break;
            case JsonBinRead.INT8ARRAY:
                n = this._getLen(data);
                value = JsonBinRead.readInt8Array(data, data.pos, n);
                break;
            case JsonBinRead.UINT8ARRAY:
                n = this._getLen(data);
                value = data.readUint8Array(data.pos, n);
                break;
            case JsonBinRead.INT16ARRAY:
                n = this._getLen(data);
                value = data.readInt16Array(data.pos, n);
                break;
            case JsonBinRead.FLOAT32ARRAY:
                n = this._getLen(data);
                value = data.readFloat32Array(data.pos, n);
                break;
            default:
                return this._readOne_other(parent, data, key, type, keyMap);
        }
        parent && key && (parent[key] = value);
        return value;
    }
    _readOne_other(parent, data, key, type, keyMap) {
        let cur = parent;
        let value;
        let n, i;
        let pos;
        switch (type) {
            case JsonBinRead.ARRAY8:
            case JsonBinRead.ARRAY16:
            case JsonBinRead.ARRAY32:
                switch (type) {
                    case JsonBinRead.ARRAY8:
                        n = data.readUint8();
                        break;
                    case JsonBinRead.ARRAY16:
                        n = data.readInt16();
                        break;
                    case JsonBinRead.ARRAY32:
                        n = data.readUint32();
                        break;
                }
                var array = value = [];
                array.length = n;
                for (i = 0; i < n; i++) {
                    type = data.readUint8();
                    array[i] = this._readOne(null, data, null, type, keyMap);
                }
                break;
            case JsonBinRead.ARRAYREFSOURCE8:
            case JsonBinRead.ARRAYREFSOURCE16:
                n = type === JsonBinRead.ARRAYREFSOURCE8 ? data.readUint8() : data.readInt16();
                pos = data.pos - this._dataStartOfs;
                value = this._readArray(data, -1, n, type, keyMap);
                this._objectRef[pos] = { array: value, pos: pos };
                break;
            case JsonBinRead.ARRAYREF:
            case JsonBinRead.ARRAYREF32:
                i = data.readByte();
                pos = type == JsonBinRead.ARRAYREF ? data.readUint16() : data.readUint32();
                let objectRef = this._objectRef[pos];
                if (!objectRef) {
                    throw "load ref err";
                    return null;
                }
                if (i == JsonBinRead.COMPRESS_NEW) {
                    value = this._readArray(data, pos + this._dataStartOfs, objectRef.array.length, type, keyMap);
                }
                else
                    value = objectRef.array;
                break;
            case JsonBinRead.OBJECT:
            case JsonBinRead.OBJECTTHISCLASS:
                if (key != null || !parent) {
                    if (type == JsonBinRead.OBJECT) {
                        cur = {};
                    }
                    else {
                        n = data.readUint16();
                        cur = this._createObjWithClass(keyMap.keyArray[n][0]);
                        if (!cur)
                            throw "jsonbin read err,no this class:" + keyMap.keyArray[n][0];
                    }
                    key && parent && (parent[key] = cur);
                }
                let keyDef;
                while (true) {
                    n = data.readUint16();
                    if (n == JsonBinRead.OBJECTEND)
                        break;
                    keyDef = keyMap.keyArray[n];
                    this._readOne(cur, data, keyDef[0], keyDef[1], keyMap);
                }
                value = cur;
                cur = parent;
                break;
        }
        (key != null) && (cur[key] = value);
        return value;
    }
    read(data, createObjWithClass = null) {
        this._createObjWithClass = createObjWithClass;
        let time = Browser.now();
        let bData = new Byte();
        let strMap;
        let binMark;
        bData.writeArrayBuffer(data);
        bData.pos = 0;
        this._objectRef = {};
        binMark = bData.readInt32();
        switch (binMark) {
            case JsonBinRead.ISJSONBIN:
                strMap = bData.readUTFString();
                break;
            case JsonBinRead.ISJSONBIN2:
            case JsonBinRead.ISJSONBIN3:
                strMap = bData.readUTFString32();
                break;
            default:
                bData.pos = 0;
                return null;
        }
        var keyMap = new ReadKeyMap();
        keyMap.strs = strMap.split(JsonBinRead.SPLITCHAR);
        keyMap.keyArray.length = keyMap.strs.length / 2;
        for (var i = 0, n = keyMap.strs.length; i < n; i += 2) {
            keyMap.keyArray[i / 2] = [keyMap.strs[i], parseInt(keyMap.strs[i + 1])];
        }
        let time2 = Browser.now();
        this._dataStartOfs = bData.pos;
        var r = {};
        this._readOne(r, bData, null, JsonBinRead.OBJECT, keyMap);
        if ((Browser.now() - time) > 10)
            console.debug("jsonbinread delay:", (Browser.now() - time) + "/" + (time2 - time), data.byteLength);
        return binMark == JsonBinRead.ISJSONBIN3 ? r.top : r;
    }
}
JsonBinRead.ISJSONBIN = 0xFFFFFF;
JsonBinRead.ISJSONBIN2 = 0xFFFFFE;
JsonBinRead.ISJSONBIN3 = 0xFFFFFD;
JsonBinRead.SPLITCHAR = String.fromCharCode(3);
JsonBinRead.COMPRESS_NEW = 1;
JsonBinRead.COMPRESS_REF = 2;
JsonBinRead.COMPRESS_REFMODIFY = 3;
JsonBinRead.NUM8 = 0;
JsonBinRead.NUM16 = 1;
JsonBinRead.NUM32 = 2;
JsonBinRead.BOOLEAN = 3;
JsonBinRead.DOUBLE = 4;
JsonBinRead.STRING = 5;
JsonBinRead.ARRAY8 = 6;
JsonBinRead.ARRAY16 = 7;
JsonBinRead.ARRAYEMPTY = 8;
JsonBinRead.ARRAYNUM8 = 9;
JsonBinRead.ARRAYNUM16 = 10;
JsonBinRead.ARRAYNUM32 = 11;
JsonBinRead.ARRAYDOUBLE = 12;
JsonBinRead.ARRAYSTRING = 13;
JsonBinRead.NULL = 14;
JsonBinRead.OBJECT = 15;
JsonBinRead.NUM16_1000 = 16;
JsonBinRead.NUM32_1000 = 17;
JsonBinRead.WORDTEXT = 18;
JsonBinRead.ARRAYBUFFER = 19;
JsonBinRead.ARRAYREF = 20;
JsonBinRead.ARRAYREFSOURCE8 = 21;
JsonBinRead.ARRAYREFSOURCE16 = 22;
JsonBinRead.ARRAYBUFFER32 = 23;
JsonBinRead.ARRAYREF32 = 24;
JsonBinRead.ARRAY32 = 25;
JsonBinRead.OBJECTTHISCLASS = 26;
JsonBinRead.NUM64 = 27;
JsonBinRead.INT8ARRAY = 28;
JsonBinRead.UINT8ARRAY = 29;
JsonBinRead.INT16ARRAY = 30;
JsonBinRead.FLOAT32ARRAY = 31;
JsonBinRead.OBJECTEND = 0x7FFF;
class ReadKeyMap {
    constructor() {
        this.keys = {};
        this.strs = ["BEGIN", 0];
        this.keyArray = [];
        this.keyIndex = 1;
    }
}
